module.exports = __webpack_public_path__ + "static/img/3.f120a57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/3.png
// module id = N266
// module chunks = 0